 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"configurar":"configurar","login":"login","favoritos":"favoritos","pedidos":"pedidos"}[chunkId]||chunkId) + "." + {"chunk-0f60e6af":"1a03a61e","chunk-1009d81e":"09597a7e","chunk-151d1bbf":"11d8fbe1","chunk-277c6ee7":"d3682753","chunk-2c57efa2":"fa8b20a3","chunk-2d0b9632":"acd27fe5","chunk-2d0c1ae7":"df5b1fe7","chunk-2d0c78e5":"d8fbca03","chunk-2d0e186f":"1e0af96f","chunk-2d225005":"962cf7cb","chunk-2d230ff4":"df739fa8","chunk-38ccfe28":"bcfe3ee6","chunk-3cb9782e":"9af82c4c","chunk-3f142b7e":"7f333ca4","chunk-3f7e6e5c":"1dc65cce","chunk-4405e632":"87c0161f","chunk-45b48dac":"22084952","chunk-4c9c71c2":"be8f1c8d","chunk-77bdedbe":"45ddb992","configurar":"2e0961bc","login":"deab7b11","chunk-4d188462":"926066ec","chunk-51f43c34":"d5b0b95d","chunk-5a5184d0":"241542d6","chunk-5abf358c":"7f725122","chunk-5de1c79e":"f527b0f5","chunk-60a83e90":"946aed5b","chunk-6d248fca":"52a5a45f","chunk-7fa83cac":"c70c8feb","chunk-a455154a":"a3895015","chunk-cd5f171e":"10c46d45","chunk-e9cb7634":"02e9f652","chunk-f0743dac":"4aefc1ec","favoritos":"d53c3fcc","pedidos":"54f753bb","chunk-2d0e149b":"9a2ad070","chunk-5345ed26":"a6185424","chunk-2597ac56":"11a5a238","chunk-2d237991":"d32bbaee","chunk-29a0125b":"18f02d40","chunk-2d0b6388":"d1edd5d2","chunk-2d0c203c":"218bb361","chunk-354ea696":"b702c982","chunk-35c0595c":"bce22138","chunk-416d73c9":"453d9f96","chunk-5cd26a06":"1af9971f","chunk-651e7c17":"2a32cc0c","chunk-9138a82a":"56a4b3b8","chunk-f32b2202":"05eb4e9a","chunk-2d0b95f3":"9e2ce8e6","chunk-2d21d4f2":"8b0ae3ab","chunk-71ab6ab7":"ce26d8fe","chunk-8fb0d0c2":"aaf3273c","chunk-66b7d1e1":"8846340c","chunk-0ebc9c34":"4d2184a0","chunk-119cdd0b":"e1cd45ee","chunk-2d0bd236":"e37dd9e4","chunk-64dfb121":"8a2cd963","chunk-6cdd03ac":"a0ac33de","chunk-a1c50a98":"11ea2982","chunk-b6300db2":"0a27c75a","chunk-33b3f790":"afef98b4","chunk-41620a69":"3260788c","chunk-248d5f53":"3e7b8186","chunk-2d0a4f12":"a9d7c8cc","chunk-2d0be13b":"09187f39","chunk-2d20826c":"15b77c4d","chunk-660e9f78":"c56450ac","chunk-14fb9cd0":"e642f936","chunk-19110b4a":"bd5dbd59","chunk-1a7f706b":"0b1754c5","chunk-2d0aeafb":"1c401f23","chunk-2d0bd52d":"d84963ee","chunk-2d0d09fa":"fee75e5e","chunk-3ffab950":"440812cb","chunk-4adb90f6":"5b62e3f0","chunk-7570903b":"4593ebdb","chunk-a81d957e":"8b0520aa","chunk-2d0dcff4":"19e1fa33","chunk-2d2085ee":"5d4fff9a","chunk-2d208fc1":"7c7f4210","chunk-6798f89b":"790618d3","chunk-6a0116ec":"41c34e88","chunk-768b32d2":"e55992a6","chunk-2d0b381d":"a78be38e"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-0f60e6af":1,"chunk-1009d81e":1,"chunk-277c6ee7":1,"chunk-2c57efa2":1,"chunk-38ccfe28":1,"chunk-3f142b7e":1,"chunk-3f7e6e5c":1,"chunk-4405e632":1,"chunk-45b48dac":1,"chunk-77bdedbe":1,"configurar":1,"login":1,"chunk-4d188462":1,"chunk-51f43c34":1,"chunk-5a5184d0":1,"chunk-5abf358c":1,"chunk-5de1c79e":1,"chunk-60a83e90":1,"chunk-6d248fca":1,"chunk-7fa83cac":1,"chunk-a455154a":1,"chunk-e9cb7634":1,"chunk-f0743dac":1,"favoritos":1,"pedidos":1,"chunk-2597ac56":1,"chunk-29a0125b":1,"chunk-354ea696":1,"chunk-35c0595c":1,"chunk-416d73c9":1,"chunk-5cd26a06":1,"chunk-651e7c17":1,"chunk-9138a82a":1,"chunk-f32b2202":1,"chunk-71ab6ab7":1,"chunk-8fb0d0c2":1,"chunk-66b7d1e1":1,"chunk-0ebc9c34":1,"chunk-119cdd0b":1,"chunk-64dfb121":1,"chunk-6cdd03ac":1,"chunk-a1c50a98":1,"chunk-b6300db2":1,"chunk-33b3f790":1,"chunk-41620a69":1,"chunk-248d5f53":1,"chunk-660e9f78":1,"chunk-14fb9cd0":1,"chunk-19110b4a":1,"chunk-1a7f706b":1,"chunk-3ffab950":1,"chunk-4adb90f6":1,"chunk-7570903b":1,"chunk-a81d957e":1,"chunk-6798f89b":1,"chunk-6a0116ec":1,"chunk-768b32d2":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"configurar":"configurar","login":"login","favoritos":"favoritos","pedidos":"pedidos"}[chunkId]||chunkId) + "." + {"chunk-0f60e6af":"594969f3","chunk-1009d81e":"63f36f3d","chunk-151d1bbf":"31d6cfe0","chunk-277c6ee7":"e02b3d1f","chunk-2c57efa2":"cffad614","chunk-2d0b9632":"31d6cfe0","chunk-2d0c1ae7":"31d6cfe0","chunk-2d0c78e5":"31d6cfe0","chunk-2d0e186f":"31d6cfe0","chunk-2d225005":"31d6cfe0","chunk-2d230ff4":"31d6cfe0","chunk-38ccfe28":"5dfc931a","chunk-3cb9782e":"31d6cfe0","chunk-3f142b7e":"0ebfe33d","chunk-3f7e6e5c":"8ca5bbf0","chunk-4405e632":"49533c1e","chunk-45b48dac":"f5eaaf42","chunk-4c9c71c2":"31d6cfe0","chunk-77bdedbe":"4032d0f4","configurar":"21dbea43","login":"83257ff9","chunk-4d188462":"d0c0c9c3","chunk-51f43c34":"c4f053d2","chunk-5a5184d0":"493e64ef","chunk-5abf358c":"c2270bab","chunk-5de1c79e":"61af0fbc","chunk-60a83e90":"ee44dd1e","chunk-6d248fca":"30014294","chunk-7fa83cac":"c0788d7e","chunk-a455154a":"dad505e3","chunk-cd5f171e":"31d6cfe0","chunk-e9cb7634":"e520e583","chunk-f0743dac":"2262fb1a","favoritos":"4bce09d8","pedidos":"740995b4","chunk-2d0e149b":"31d6cfe0","chunk-5345ed26":"31d6cfe0","chunk-2597ac56":"8acb10c3","chunk-2d237991":"31d6cfe0","chunk-29a0125b":"7b42758e","chunk-2d0b6388":"31d6cfe0","chunk-2d0c203c":"31d6cfe0","chunk-354ea696":"6430b842","chunk-35c0595c":"7736fd9b","chunk-416d73c9":"1c1a09d2","chunk-5cd26a06":"36fd9ce3","chunk-651e7c17":"f13d1b7e","chunk-9138a82a":"175e5435","chunk-f32b2202":"29a8ea01","chunk-2d0b95f3":"31d6cfe0","chunk-2d21d4f2":"31d6cfe0","chunk-71ab6ab7":"2f3c6ed2","chunk-8fb0d0c2":"f7fe1825","chunk-66b7d1e1":"183cd887","chunk-0ebc9c34":"38e5bd88","chunk-119cdd0b":"4e054daf","chunk-2d0bd236":"31d6cfe0","chunk-64dfb121":"0ab50947","chunk-6cdd03ac":"95e78945","chunk-a1c50a98":"553b31b7","chunk-b6300db2":"2c15c81f","chunk-33b3f790":"273a6ad0","chunk-41620a69":"b6d6d8f9","chunk-248d5f53":"36a20d09","chunk-2d0a4f12":"31d6cfe0","chunk-2d0be13b":"31d6cfe0","chunk-2d20826c":"31d6cfe0","chunk-660e9f78":"cd5fc97c","chunk-14fb9cd0":"8384fdc7","chunk-19110b4a":"c57487b5","chunk-1a7f706b":"0e099750","chunk-2d0aeafb":"31d6cfe0","chunk-2d0bd52d":"31d6cfe0","chunk-2d0d09fa":"31d6cfe0","chunk-3ffab950":"93ff1f13","chunk-4adb90f6":"c6437479","chunk-7570903b":"01212ce5","chunk-a81d957e":"93b00670","chunk-2d0dcff4":"31d6cfe0","chunk-2d2085ee":"31d6cfe0","chunk-2d208fc1":"31d6cfe0","chunk-6798f89b":"d4ecac1f","chunk-6a0116ec":"3e41a13e","chunk-768b32d2":"e80e9450","chunk-2d0b381d":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
